import React from 'react';

function LargeLogoSVG({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      id="Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 675 164"
      className={className}
    >
      <defs>
        <style>{`
          .st0 {
            fill: #2cc295;
          }
          .st1 {
            fill: url(#Unbenannter_Verlauf);
            fill-opacity: .2;
          }
          .st2 {
            fill: #044937;
          }
          .st3 {
            fill: #00df82;
          }
          .st4 {
            fill: #021a1a;
          }
        `}</style>
        <linearGradient
          id="Unbenannter_Verlauf"
          data-name="Unbenannter Verlauf"
          x1="82"
          y1="-2420.7"
          x2="82"
          y2="-2584.7"
          gradientTransform="translate(0 -2420.7) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#021a1a" stopOpacity="0" />
          <stop offset="1" stopColor="#021a1a" />
        </linearGradient>
      </defs>
      <g id="Ebene_11" data-name="Ebene_1">
        <path
          className="st4"
          d="M215.7,82c0-5.3,1.2-10,3.5-14.2,2.4-4.2,5.7-7.5,9.8-9.8,4.2-2.4,8.8-3.5,14-3.5s11.3,1.5,15.8,4.6,7.7,7.4,9.5,12.8h-12.4c-1.2-2.6-3-4.5-5.2-5.8-2.2-1.3-4.8-1.9-7.7-1.9s-5.9.7-8.4,2.2c-2.4,1.4-4.3,3.5-5.7,6.2-1.3,2.7-2,5.8-2,9.4s.7,6.7,2,9.4c1.4,2.7,3.3,4.8,5.7,6.2,2.5,1.4,5.3,2.2,8.4,2.2s5.5-.6,7.7-1.9c2.3-1.3,4-3.3,5.2-5.9h12.4c-1.8,5.5-5,9.8-9.5,12.9-4.5,3-9.7,4.6-15.8,4.6s-9.8-1.2-14-3.5c-4.1-2.4-7.4-5.6-9.8-9.8-2.4-4.2-3.5-8.9-3.5-14.2h0ZM275.5,87.5c0-4.3.8-8.2,2.5-11.5s4.1-5.9,7-7.7c3-1.8,6.3-2.7,10-2.7s6,.6,8.3,1.9c2.4,1.3,4.3,2.9,5.8,4.9v-6.1h10.9v42.7h-10.9v-6.2c-1.4,2-3.3,3.7-5.8,5-2.4,1.3-5.2,1.9-8.4,1.9s-6.9-.9-9.9-2.8c-2.9-1.9-5.3-4.4-7-7.8s-2.5-7.3-2.5-11.6h0ZM309.2,87.6c0-2.6-.5-4.9-1.5-6.7-1-1.9-2.4-3.3-4.2-4.3-1.7-1-3.6-1.5-5.6-1.5s-3.9.5-5.6,1.5-3.1,2.4-4.2,4.3c-1,1.9-1.5,4.1-1.5,6.6s.5,4.8,1.5,6.8c1.1,1.9,2.5,3.4,4.2,4.4s3.6,1.5,5.6,1.5,3.9-.5,5.6-1.5,3.1-2.5,4.2-4.3c1-1.9,1.5-4.2,1.5-6.8ZM342.1,72.9c1.4-2.3,3.2-4,5.4-5.3,2.3-1.3,4.8-1.9,7.7-1.9v11.3h-2.9c-3.4,0-6,.8-7.7,2.4s-2.5,4.4-2.5,8.3v21.3h-10.8v-42.7h10.8v6.6ZM380,65.6c3.2,0,6,.6,8.4,1.9,2.4,1.2,4.3,2.9,5.7,4.9v-6.1h10.9v43c0,4-.8,7.5-2.4,10.6s-4,5.6-7.2,7.4c-3.2,1.9-7,2.8-11.6,2.8s-11.1-1.4-15-4.2-6-6.7-6.6-11.6h10.7c.6,2,1.8,3.5,3.6,4.6,1.9,1.2,4.2,1.8,6.9,1.8s5.7-1,7.6-2.9c2-1.9,2.9-4.7,2.9-8.5v-6.6c-1.4,2-3.3,3.7-5.8,5-2.4,1.3-5.2,2-8.3,2s-6.9-.9-9.9-2.8-5.3-4.4-7.1-7.8c-1.7-3.4-2.5-7.3-2.5-11.6s.8-8.2,2.5-11.5,4.1-5.9,7-7.7c3-1.8,6.3-2.7,10-2.7h.2,0ZM394.2,87.6c0-2.6-.5-4.9-1.5-6.7-1-1.9-2.4-3.3-4.2-4.3-1.7-1-3.6-1.5-5.6-1.5s-3.9.5-5.6,1.5-3.1,2.4-4.2,4.3c-1,1.9-1.5,4.1-1.5,6.6s.5,4.8,1.5,6.8c1.1,1.9,2.5,3.4,4.2,4.4s3.6,1.5,5.6,1.5,3.9-.5,5.6-1.5,3.1-2.5,4.2-4.3c1-1.9,1.5-4.2,1.5-6.8ZM435.3,109.7c-4.1,0-7.8-.9-11.1-2.7-3.3-1.9-5.9-4.4-7.8-7.8-1.9-3.3-2.8-7.2-2.8-11.6s1-8.2,2.9-11.6c2-3.3,4.6-5.9,7.9-7.7,3.3-1.9,7.1-2.8,11.2-2.8s7.8.9,11.2,2.8c3.3,1.8,6,4.4,7.9,7.7,2,3.3,2.9,7.2,2.9,11.6s-1,8.2-3,11.6c-2,3.3-4.6,5.9-8,7.8-3.3,1.8-7.1,2.7-11.3,2.7h0ZM435.3,100.3c2,0,3.8-.5,5.5-1.4,1.7-1,3.1-2.4,4.2-4.3,1-1.9,1.5-4.2,1.5-6.9,0-4.1-1.1-7.2-3.2-9.3-2.1-2.2-4.7-3.3-7.8-3.3s-5.7,1.1-7.8,3.3c-2.1,2.2-3.1,5.3-3.1,9.3s1,7.2,3,9.4c2.1,2.2,4.6,3.2,7.7,3.2h0ZM512.4,109h-10.8l-24.5-36.9v36.9h-10.8v-53.9h10.8l24.5,37v-37h10.8v53.9ZM563.5,86.7c0,1.5,0,2.9-.3,4.2h-31.2c.3,3.1,1.3,5.5,3.2,7.3,1.9,1.7,4.2,2.6,7,2.6,4,0,6.9-1.7,8.6-5.2h11.6c-1.2,4.1-3.6,7.5-7.1,10.2-3.5,2.6-7.8,3.9-12.9,3.9s-7.8-.9-11.1-2.7c-3.2-1.9-5.8-4.4-7.6-7.8-1.8-3.3-2.7-7.2-2.7-11.6s.9-8.3,2.7-11.6c1.8-3.3,4.3-5.9,7.6-7.7,3.2-1.8,7-2.7,11.2-2.7s7.7.9,10.9,2.6,5.7,4.2,7.5,7.5c1.8,3.2,2.7,6.9,2.7,11h-.1ZM552.3,83.6c0-2.8-1.1-5-3-6.6-2-1.7-4.3-2.5-7.2-2.5s-4.9.8-6.8,2.5c-1.8,1.6-2.9,3.8-3.3,6.7h20.3ZM595.8,109l-8.8-13.3-7.8,13.3h-11.6l14-21.4-14.1-21.3h12.2l8.7,13.2,7.9-13.2h11.6l-14,21.3,14.2,21.4h-12.3ZM638.2,109l-8.8-13.3-7.8,13.3h-11.6l14-21.4-14.1-21.3h12.2l8.7,13.2,7.9-13.2h11.6l-14,21.3,14.2,21.4h-12.3Z"
        />
        <g>
          <rect
            className="st2"
            y="0"
            width="164"
            height="164"
            rx="15"
            ry="15"
          />
          <rect
            className="st1"
            y="0"
            width="164"
            height="164"
            rx="15"
            ry="15"
          />
          <path
            className="st0"
            d="M22.9,125.7s-.3.3-.3.8c0,.8.6,1.4,1.5,1.4h28c.6,0,.7,0,1.5-.8l12.7-16.4c-3-9-7.5-16.9-11.7-25"
          />
          <path
            className="st0"
            d="M137.7,37h-28c-.6,0-.9,0-1.2.6l-10.8,13.8c6.9,5.3,13.2,10.9,18.9,17.1,0,0,19.8-25.5,22.5-28.8.6-.9,1-2.7-1.4-2.7Z"
          />
          <path
            className="st3"
            d="M41.6,37h-21.1c-.9,0-1.5.6-1.5,1.4s0,1.2.3,1.4c28,21.7,48.2,52.5,56.1,87.8,0,0,0,.3.3.3h28.9c.9,0,1.7-.5,1.5-1.4h0c-8.4-36.1-31.9-67.5-64.5-89.5Z"
          />
          <path
            className="st3"
            d="M145.3,126.5c-9.9-36.1-36.8-67.5-73.5-89.5h-20.5c-.9,0-1.5.6-1.5,1.4s.3,1.1.6,1.4c32.2,21.7,55.5,52.5,64.2,87.8,0,0,0,.3.3.3h28.9c.9,0,1.5-.6,1.5-1.4h0Z"
          />
        </g>
      </g>
    </svg>
  );
}

export { LargeLogoSVG };
